import DocMarkdown from "@/components/DocMarkdown";

import { bridgeDocs } from "../bridge-docs";

/** 接入示例 tab：以 Bridge SDK 文档为入口，支持站内跳转到其它 Bridge 文档。 */
export default function IntegrationSampleTab() {
  return <DocMarkdown docs={bridgeDocs} docPath="bridge/007-sdk/index.md" />;
}
